import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { AppService } from '@app/_core/services/app.service';
import { LoaderService } from '@app/_core/services/loader.service';
import { LoginService } from '@app/_core/services/login.service';
import { SecurityService } from '@app/_core/services/security.service';
import { TmService } from '@app/_core/services/tm.service';
import { UserService } from '@app/_core/services/user.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EMPTY, Subject, timer } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, exhaustMap, map, switchMap, takeUntil } from 'rxjs/operators';
import { HubManager } from 'src/app/pages/hubs/common/HubManager';
import { environment } from '@environments/environment';
import { EncryDecryService } from '@app/_core/services/encrydecry.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  /*
    var clientAbbr = null,
    clientShortName = null,
    clientFullName = null,
    clientAttrs = {},
    clientID = null,
    avatarLocation = null,
    accessibleClients = [],
    logoutProcessing = false,
    serverSyncProps = {},
    whatsNewHTML = null,
    version = null, sharedApplicationKey =null,
    restartForced = false;*/

  getUserErrorCount = 0;
  blockGetUserCalls = false;
  getUserId!: any;
  SSOEnabled:boolean = false;
  companyField: string = '';
  idpConfig: any = {};
  //confirmPasswordField: string = '';
  headerText = null;
  secureEmailRequest = false;
  secureEmailAccessKey = null;
  secureEmailService = null;
  userID = null;
  emailAddress = null;
  newUser = false;
  //hasPassword = true;
  hasSSO = false;
  showGoogleLogin = false;
  gettingLoginConfig = false;
  companyPrompt = null;

  errorMessage = '';
  //ssoBtn,
  //orField,
  //googleLoginWrapper = null,
  //fieldWidth = 280,
  //fieldHeight = 40,
  //fieldFontSize = '1rem',
  autoLogin = false;
  qsUsername = null;
  //qsPassword = null;
  qsCompany = null;
  un = null;
  pw = null;
  lastCompany = null;
  pendingCompany = false;
  pendingCallback = null;

  csrfCookie = '';
  companyCode: any = '';
  loginModel = {
    uname: '',
    pcode: '',
    company: '',
    idpShortName: '',
  };
  returnUrl = '';
  toggleEye: boolean = true;
  isSSOClicked: boolean = false;
  isRemeber: boolean = false;
  isMouseOut: boolean = false;
  /** SECURITY: Tracks whether the username field has a value without exposing the value itself in the DOM. */
  usernameHasValue: boolean = false;
  loginInfo: any = {};
  clientAbbreviation: any = '';
  unexpectedError: boolean = false;
  getUserTimeout: any;
  private companyCodeSubject$ = new Subject<string>();
  private destroy$ = new Subject<void>();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService,
    public bsModalRef: BsModalRef,
    private userService: UserService,
    private tmService: TmService,
    private securityService: SecurityService,
    private appService: AppService,
    private loaderService: LoaderService,
    private webStorageService: WebStorageService,
    private modalService: BsModalService,
    private hubManager: HubManager,
    private encrypt: EncryDecryService
  ) {}

  ngOnInit(): void {

    // Setup company code debouncing
    this.companyCodeSubject$.pipe(
      debounceTime(400),  // Wait 400ms after user stops typing
      distinctUntilChanged(),  // Only proceed if value changed
      switchMap(code => this.userService.getLoginConfig(code)),
      takeUntil(this.destroy$)
    ).subscribe(
      (data: any) => {
        const isValid = ResponseHandler.processResponse(data, 'getLoginConfig');
        if (isValid) {
          this.loginInfo = data.Response.Data;
        }
      },
      error => {
        console.log('Error fetching login config:', error);
        this.loginInfo = {};
      }
    );
    
    this.loaderService.display(false);
    this.unexpectedError = this.route.snapshot.queryParams['unexpectedError'] === 'true';
    //this.hubManager.eAppWillCloseHandler();
      this.hubManager.setTMHubJoinedStatus(false);
    this.appService.setblockGetUserCalls(true);
    let returnParam = this.route.snapshot.queryParams['returnUrl'];
    if (!returnParam) {
      returnParam = localStorage.getItem('returnUrl') || undefined;
      let fp = localStorage.getItem('returnFilePath');
      if (fp && !this.route.snapshot.queryParams['filePath']) {
        this.route.snapshot.queryParams['filePath'] = fp;
      }
    }

    if (returnParam) {
      // Preserve full returnUrl including company prefix (e.g. /BCH/audio)
      this.returnUrl = returnParam.startsWith('/') ? returnParam : '/' + returnParam;
    } else {
      this.returnUrl = '/Queue';
    }
    // keep service in sync so login service can use returnUrl where needed
    this.loginService.returnUrl = this.returnUrl;
    // clear fallback storage after consuming it
    localStorage.removeItem('returnUrl');
    localStorage.removeItem('returnFilePath');

    // Clear all storage to ensure a clean login state (preserve previous read of returnUrl)
    localStorage.clear();
    sessionStorage.clear();

    let token= this.route.snapshot.queryParamMap.get('token');
    let client = this.route.snapshot.queryParamMap.get('client');
    this.errorMessage =this.route.snapshot.queryParamMap.get('Status');

    if(token && token.length >0 && client && client.length >0){
      this.SSOEnabled=true;
      this.getSSOCallbackLoggedIn(token,client);
    }  
    if(this.router.url.includes('/SwitchPod')){
      this.SSOEnabled=true;
      let creds = this.route.snapshot.queryParamMap.get('creds');
      this.switchenv(creds);
    }
    if (this.unexpectedError) {
      this.errorMessage = 'An unexpected error has occurred. Please log in to continue.';
    }
    //this.companyCode = localStorage.getItem('company') || '';
    //this.companyCode = Utils.fetch('companyCode');
    //this.csrfCookie = localStorage.getItem('csrfCookie') || '';

    //this.getUser();

    /*
    this.getUserId = setInterval(() => {
      this.getUser();
    }, 5000);
    
    if (this.companyCode) {
      this.getLoginInfo(this.companyCode);
    }
    */
  }
  getSSOCallbackLoggedIn(token,client){
   this.loginService.getSSOCallbackLoggedIn(token,client);
  }

  /**
   * SECURITY: One-way input handlers replace [(ngModel)] on all credential fields.
   * Data flows inward (DOM → model) only; model values are never reflected back into DOM attributes,
   * breaking the SAST taint path that flags [(ngModel)] as a privacy violation.
   */
  onCompanyInput(event: Event): void {
    this.loginModel.company = (event.target as HTMLInputElement).value;
  }

  onUsernameInput(event: Event): void {
    this.loginModel.uname = (event.target as HTMLInputElement).value;
    // Update flag used for CSS class binding — avoids exposing the value itself in the DOM
    this.usernameHasValue = this.loginModel.uname.length > 0;
  }

  onPasswordInput(event: Event): void {
    this.loginModel.pcode = (event.target as HTMLInputElement).value;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changedCompanyCode(_event: any) {
    this.loginInfo = {};
    if (this.loginModel.company.length >= 3) {
      //this.getLoginInfo(this.loginModel.company);
      this.companyCodeSubject$.next(this.loginModel.company);  // Emit to subject
    }
  }

  routeFP() {
    this.router.navigate(['forgot-password'], {
      state: { company: this.loginModel.company, username: this.loginModel.uname },
    });
  }

  login() {
    if (!this.loginModel[`company`]) {
      this.errorMessage = 'Company Code cannot be empty';
      return;
    } else if (!this.loginModel[`pcode`] || !this.loginModel[`uname`]) {
      this.errorMessage = 'Username/Password cannot be empty';
      return;
    }
    this.loginModel["SessionID"]=this.loginInfo?.SessionId;
    this.loginService.loginModel = this.loginModel;
    this.loginService.getLoggedIn();
  }

  getUser() {
    if (!this.blockGetUserCalls) {
      this.userService
        .getUser(true, null,0)
        .pipe(
          map((data: any) => {
            const isValid = ResponseHandler.processResponse(data, 'getUser');
            if (isValid) {
              this.getUserErrorCount = 0;
              if (data.Response.User) {
                if (
                  this.securityService.clientAbbr != null &&
                  this.securityService.clientAbbr !== data.Response.ClientAbbreviation
                ) {
                  this.blockGetUserCalls = true;
                  alert('Client context changed in another window. Click OK to reload.');
                } else {
                  this.appService.setClientAppParams(data.Response.LoginParams);
                  this.securityService.setUserData(data.Response);
                  //  callback(data.Response.User);
                }
              } else {
                const user = localStorage.getItem('user') || {};
                if (user) {
                  this.blockGetUserCalls = true;
                  //alert("Your session has ended. Click OK to log back in.")
                  this.logout();
                } else {
                  //load  companyv
                  this.loginModel.company = this.companyCode;
                }
              }
            } else {
              this.getUserErrorCount++;
              if (this.getUserErrorCount < 5)
                timer(0, 1000)
                  .pipe(
                    exhaustMap(() => this.userService.getUser(true, null))
                  )
                  .subscribe(data => {
                    // existing response handling logic
                  });
              else {
                this.blockGetUserCalls = true;
                alert(
                  'An unexpected error has occurred.  Click OK to log back in.<br /><br />Status: ' +
                    status +
                    '<br />Response: '
                );
                this.logout();
                //errorCallback('Invalid Response');
              }
            }
          }),
          catchError(error => {
            console.log(error);
            return EMPTY;
          })
        )
        .subscribe();
    }
  }

  getLoginInfo(companyCode: string) {
    this.userService
      .getLoginConfig(companyCode)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'getLoginConfig');
          if (isValid) {
            this.loginInfo = data.Response.Data;
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
  LoginWithSSO(companyCode){
    this.userService.getLoginWithSSO(companyCode);
    // this.userService.getLoginWithSSO(companyCode).subscribe(
    //   res => {
    //     window.location.href = res.EndpointUrl;
    //     console.log('API Error successfully logged into backend:', res);
    //   },
    //   logError => {
    //     console.error('Failed to log API error into backend:', logError);
    //   }
    // );
  }

  logout() {}

  getErrorMessage() {
    return this.loginService.getErrorMessage('');
  }

  addMouseOutclass() {
    this.isMouseOut = true;
  }
  RemoveMouseOutclass() {
    this.isMouseOut = false;
  }
  switchenv(creds){    
    this.loginService.SwitchPod(creds); 
  }
  ngOnDestroy(): void {
    this.getUserTimeout && clearTimeout(this.getUserTimeout);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
